import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

/**
 * Mismo cierre para el menú del avatar y el botón de encendido del sidebar:
 * revoca el refresh token, limpia el storage y abre el login.
 */
export function logoutToLogin(auth: AuthenticationService, router: Router): void {
  auth.logout();
  void router.navigate(['/authentication/login']);
}
